import { api } from "./request";

export const GOOGLE_REDIRECT_URL =
  process.env.REACT_APP_GOOGLE_REDIRECT_URL || "domain2";

export const PlanNames = {
  Free: "Free",
  Standard: "Standard",
  Professional: "Professional",
  Team: "Team",
  Business: "Business",
} as const;

export const PlanDurations = {
  month: "month",
  year: "year",
} as const;

export type EPlanDuration = (typeof PlanDurations)[keyof typeof PlanDurations];

export type EPlanName = (typeof PlanNames)[keyof typeof PlanNames];

export interface ISocialCallback {
  authuser: string;
  code: string;
  prompt: string;
  scope: string;
}

interface PlanAttributes {
  max_document_chats: number;
  max_video_chats: number;
  max_audio_chats: number;
}

export interface IActivePlan {
  id: number;
  attributes: PlanAttributes;
  team_id: number;
  status: string;
  credits: number;
  document_chat_count: number;
  video_chat_count: number;
  audio_chat_count: number;
  is_cancelled: number;
  end_date: string;
  created_at: string;
  updated_at: string;
  name: EPlanName;
  total_credits: number;
  total_earned_credits: number;
  cost: string;
  renewal_date: string;
  duration: EPlanDuration;
}

export interface ICurrentTeam {
  id: number;
  name: string;
  role: UserRolesType;
  slug: string;
}

export type UserRolesType = (typeof UserRoles)[keyof typeof UserRoles];
export const UserRoles = {
  admin: "admin",
  manager: "manager",
  member: "member",
} as const;

export interface IUser {
  activeSubscription: IActivePlan;
  id: number;
  name: string;
  email: string;
  email_verified_at: string;
  stripe_id: string;
  avatar: boolean;
  two_factor_secret: string;
  two_factor_recovery_codes: string;
  created_at: string;
  updated_at: string;
  language?: string;
  team: ICurrentTeam;
  referral_token: string;
  // social_providers?: googleAuthToken[];
}

export interface IUserDetail {
  token: string;
  user: IUser;
}

export interface IVerifyEmail {
  data: IUserDetail;
  message: string;
}


export const socialRedirect = () => {
  return new Promise((resolve, reject) => {
    api
      .get(`/api/auth/social/google?domain=${GOOGLE_REDIRECT_URL}`)
      .then((res: any) => {
        resolve(res.data);
      })
      .catch((err: any) => {
        reject(err);
      });
  });
};

export const socialCallback = (data: ISocialCallback) => {
  return new Promise((resolve, reject) => {
    const { authuser, code, prompt, scope } = data;
    const apiUrl = `/api/auth/social/callback/google?code=${code}&scope=${scope}&authuser=${authuser}&prompt=${prompt}&domain=${GOOGLE_REDIRECT_URL}`;

    api
      .get(apiUrl)
      .then((res: any) => {
        resolve(res.data);
      })
      .catch((err: any) => {
        reject(err);
      });
  });
};

export const getCreditLimits = () => {
  return new Promise((resolve, reject) => {
    api
      .get("/api/user/daily-limit")
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getActivePlan = () => {
  return new Promise((resolve, reject) => {
    api
      .get("/api/user/plan")
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const verifyToken = (data: { user_id: number; email: string }) => {
  return new Promise((resolve, reject) => {
    api
      .post("/api/auth/verify-token", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};